import * as React from 'react';

export const createPersistedState = (storageKey: string) =>
  function usePersistedState<State extends string>(initialState: State) {
    const [value, setValue] = React.useState(initialState);

    React.useEffect(() => {
      const value = window.localStorage.getItem(storageKey);
      if (value !== null) {
        setValue(value as State);
      }
    }, []);

    React.useEffect(() => {
      const onStorageEvent = () => {
        const latestValue = window.localStorage.getItem(storageKey);
        if (latestValue !== null && latestValue !== value) {
          setValue(latestValue as State);
        }
      };

      window.addEventListener('storage', onStorageEvent);

      return () => window.removeEventListener('storage', onStorageEvent);
    }, [value]);

    const valueSetter = React.useCallback(function valueSetter(
      newValue: State
    ) {
      setValue(newValue);
      window.localStorage.setItem(storageKey, newValue);
    },
    []);

    return [value, valueSetter] as const;
  };
